// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Join table: which adapters support which action catalog entries.
 * Composite PK (action_catalog_id, adapter_id) in `PostgreSQL`.
 */
export class ActionCatalogAdapter implements flatbuffers.IUnpackableObject<ActionCatalogAdapterT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ActionCatalogAdapter {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsActionCatalogAdapter(
    bb: flatbuffers.ByteBuffer,
    obj?: ActionCatalogAdapter,
  ): ActionCatalogAdapter {
    return (obj || new ActionCatalogAdapter()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsActionCatalogAdapter(
    bb: flatbuffers.ByteBuffer,
    obj?: ActionCatalogAdapter,
  ): ActionCatalogAdapter {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ActionCatalogAdapter()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  actionCatalogId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startActionCatalogAdapter(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addActionCatalogId(
    builder: flatbuffers.Builder,
    actionCatalogIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, actionCatalogIdOffset, 0);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, adapterIdOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, updatedAtOffset, 0);
  }

  static endActionCatalogAdapter(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // action_catalog_id
    builder.requiredField(offset, 6); // adapter_id
    return offset;
  }

  unpack(): ActionCatalogAdapterT {
    return new ActionCatalogAdapterT(
      this.actionCatalogId() !== null ? this.actionCatalogId()!.unpack() : null,
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: ActionCatalogAdapterT): void {
    _o.actionCatalogId = this.actionCatalogId() !== null ? this.actionCatalogId()!.unpack() : null;
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): ActionCatalogAdapterT {
    const t = new ActionCatalogAdapterT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("action_catalog_id")) {
      t.actionCatalogId = this.actionCatalogId() !== null ? this.actionCatalogId()!.unpack() : null;
    }
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class ActionCatalogAdapterT implements flatbuffers.IGeneratedObject {
  constructor(
    public actionCatalogId: UuidT | null = null,
    public adapterId: UuidT | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.actionCatalogId === null || this.actionCatalogId === undefined) {
      throw new Error('Required field "action_catalog_id" is not set');
    }
    if (this.adapterId === null || this.adapterId === undefined) {
      throw new Error('Required field "adapter_id" is not set');
    }
    const actionCatalogId = this.actionCatalogId !== null ? this.actionCatalogId!.pack(builder) : 0;
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    ActionCatalogAdapter.startActionCatalogAdapter(builder);
    ActionCatalogAdapter.addActionCatalogId(builder, actionCatalogId);
    ActionCatalogAdapter.addAdapterId(builder, adapterId);
    ActionCatalogAdapter.addCreatedAt(builder, createdAt);
    ActionCatalogAdapter.addUpdatedAt(builder, updatedAt);

    return ActionCatalogAdapter.endActionCatalogAdapter(builder);
  }

  clone(): ActionCatalogAdapterT {
    const obj = new ActionCatalogAdapterT();
    obj.actionCatalogId = this.actionCatalogId !== null ? this.actionCatalogId!.clone() : null;
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: ActionCatalogAdapterT): boolean {
    if (this.actionCatalogId !== null && other.actionCatalogId !== null) {
      if (!this.actionCatalogId!.equals(other.actionCatalogId!)) return false;
    } else if (this.actionCatalogId !== other.actionCatalogId) return false;
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyActionCatalogAdapter(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "action_catalog_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "adapter_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
